import { createReducer, on } from '@ngrx/store';
import { setExpenseDateRangeSelection, clearExpenseDateRangeSelection } from './expenseDateRangeSelection.actions';
import { initialExpenseWeekState } from './expenseDateRangeSelection.state';

export const expenseDateRangeSelectionReducer = createReducer(
  initialExpenseWeekState,
  on(setExpenseDateRangeSelection, (state, { week }) => ({ ...state, expenseDateRangeSelection : week })),
  on(clearExpenseDateRangeSelection, state => ({ ...state, expenseDateRangeSelection : null }))
);